import { memo } from "react";
import PrimeBadge from "../../../../../components/primeBadge/PrimeBadge";
import { formatFullStamp, formatListStamp } from "../../../../../utils/chatTime";
import StatusPill from "../../statusPill/StatusPill";
import { categoryLabel, previewText } from "../../ticketMeta";
import styles from "./oneTicket.module.css";

// One ticket in the queue: subject and last activity; status, player,
// category and code; the last message (support's own marked), the unread
// count and the player's rating.
const OneTicket = ({ ticket, isActive, onOpen, timeZone }) => {
  const player = ticket.userId;
  const unread = ticket.unreadByAdmin || 0;
  const lastAt = ticket.lastMessageAt || ticket.updatedAt || ticket.createdAt;
  const at = lastAt ? new Date(lastAt) : null;

  const className = [styles.row, isActive && styles.active, unread > 0 && styles.unread]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={className}
      onClick={() => onOpen(ticket)}
      aria-current={isActive ? "true" : undefined}
    >
      <span className={styles.topLine}>
        <span className={styles.subject} dir="auto">
          {ticket.subject}
        </span>
        {at && (
          <time className={styles.time} dateTime={lastAt} title={formatFullStamp(at, timeZone)}>
            {formatListStamp(at, timeZone)}
          </time>
        )}
      </span>

      <span className={styles.metaLine}>
        <StatusPill status={ticket.status} />
        <span className={styles.player} dir="auto">
          {player?.name || "لاعب"}
        </span>
        <PrimeBadge
          isPrime={player?.isPrime}
          primeTier={player?.primeTier}
          size="small"
          className={styles.badge}
        />
        <span className={styles.sep}>·</span>
        <span className={styles.category}>{categoryLabel(ticket.category)}</span>
        {ticket.code && (
          <span className={styles.code} dir="ltr">
            {ticket.code}
          </span>
        )}
        {ticket.rating ? (
          <span className={styles.rating} title={`تقييم اللاعب ${ticket.rating}/5`}>
            ★ {ticket.rating}
          </span>
        ) : null}
      </span>

      <span className={styles.bottomLine}>
        <span className={styles.preview}>
          {ticket.lastSenderRole === "admin" && (
            <span className={styles.previewAuthor}>الدعم:</span>
          )}
          {/* Its own direction, so an English message is cut at its end. */}
          <span className={styles.previewText} dir="auto">
            {previewText(ticket.lastMessage) || "—"}
          </span>
        </span>
        {unread > 0 && (
          <span className={styles.count} aria-label={`${unread} غير مقروءة`}>
            {unread > 99 ? "99+" : unread}
          </span>
        )}
      </span>
    </button>
  );
};

export default memo(OneTicket);
